import $ from 'jquery';

function initWebReportFilter() {
    $('.js-filter-web-report').on('click', function(e) {
        const button = $(e.target);
        const termId = button.data('termId');

        $('.js-filter-web-report').removeClass('button-filter--active');
        button.addClass('button-filter--active');

        $.ajax({
            type: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'filter_web_report_list',
                termId: termId,
            },
            success: function(res) {
                $('#js-web-reports').html(res);
            },
            error: function(e) {
                console.log(e);
            }
        });
    });
}

export default initWebReportFilter;
